// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"af287679","150":"f7e16111"}[chunkId] + ".chunk.js";
};